import React, { useState } from 'react';
import { FiTool, FiList, FiMail, FiUsers, FiUserPlus } from 'react-icons/fi';
import AddUserForm from '../components/AddUserForm';
import UserManagement from '../components/UserManagement';
import { useAuth } from '../context/AuthContext';

interface SettingsCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  isImplemented?: boolean;
  content?: React.ReactNode;
}

const SettingsCard: React.FC<SettingsCardProps> = ({ icon, title, description, isImplemented = false, content }) => (
  <div className="bg-white shadow rounded-lg p-6">
    <div className="flex items-start">
      <div className="p-3 bg-gray-100 rounded-full mr-4">
        {icon}
      </div>
      <div className="flex-1">
        <h3 className="text-lg font-bold text-gray-900">{title}</h3>
        <p className="text-gray-600 mt-1">{description}</p>
        {!isImplemented && !content && (
          <div className="mt-4">
            <span className="px-3 py-1 bg-yellow-100 text-yellow-800 text-xs font-semibold rounded-full">
              Coming Soon
            </span>
          </div>
        )}
      </div>
    </div>
    {content && <div className="mt-6">{content}</div>}
  </div>
);

const SettingsPage: React.FC = () => {
  const { user } = useAuth();
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleUserListUpdate = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Application Settings</h1>
      <div className="space-y-6">
        {user?.role === 'admin' && (
          <>
            <SettingsCard
              icon={<FiUsers className="h-6 w-6 text-gray-600" />}
              title="User Management"
              description="View all users, manage their access, reset passwords, and control user accounts."
              content={<UserManagement key={refreshTrigger} onUserListUpdate={handleUserListUpdate} />}
            />
            <SettingsCard
              icon={<FiUserPlus className="h-6 w-6 text-gray-600" />}
              title="Add New User"
              description="Create new user accounts and assign them roles."
              content={<AddUserForm onUserListUpdate={handleUserListUpdate} />}
            />
          </>
        )}
        {/* <SettingsCard
          icon={<FiTool className="h-6 w-6 text-gray-600" />}
          title="Form Field Management"
          description="Dynamically add, remove, or modify fields in the employee application form. This will allow for extending the data capture without requiring code changes."
        />
        <SettingsCard
          icon={<FiList className="h-6 w-6 text-gray-600" />}
          title="Status Workflow Management"
          description="Customize the statuses available in the employee lifecycle (e.g., 'New Submission', 'Candidate'). Define transition rules between statuses."
        />
        <SettingsCard
          icon={<FiMail className="h-6 w-6 text-gray-600" />}
          title="Notification Templates"
          description="Edit the content of the emails sent to candidates and employees (e.g., welcome email, rework request). Use placeholders for dynamic data."
        /> */}
      </div>
    </div>
  );
};

export default SettingsPage;
